// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see WidgetsConfigurationInstallEvent
 */
export var WidgetsConfigurationInstall = function (_a) {
    var widgetSize = _a.widgetSize, widgetType = _a.widgetType, intentDescription = _a.intentDescription;
    return ({
        name: "Widgets Configuration Install",
        parameters: {
            cdf_entity: "Widgets",
            cdf_action: "Configuration",
            widget_size: widgetSize !== undefined && widgetSize !== null ? widgetSize.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            widget_type: widgetType !== undefined && widgetType !== null ? widgetType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            intent_description: intentDescription !== undefined && intentDescription !== null ? intentDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WidgetsConfigurationDeleteEvent
 */
export var WidgetsConfigurationDelete = function (_a) {
    var widgetSize = _a.widgetSize, widgetType = _a.widgetType, intentDescription = _a.intentDescription;
    return ({
        name: "Widgets Configuration Delete",
        parameters: {
            cdf_entity: "Widgets",
            cdf_action: "Configuration",
            widget_size: widgetSize !== undefined && widgetSize !== null ? widgetSize.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            widget_type: widgetType !== undefined && widgetType !== null ? widgetType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            intent_description: intentDescription !== undefined && intentDescription !== null ? intentDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WidgetsConfigurationUpdateEvent
 */
export var WidgetsConfigurationUpdate = function (_a) {
    var widgetSize = _a.widgetSize, widgetType = _a.widgetType, newIntentDescription = _a.newIntentDescription, oldIntentDescription = _a.oldIntentDescription;
    return ({
        name: "Widgets Configuration Update",
        parameters: {
            cdf_entity: "Widgets",
            cdf_action: "Configuration",
            widget_size: widgetSize !== undefined && widgetSize !== null ? widgetSize.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            widget_type: widgetType !== undefined && widgetType !== null ? widgetType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_intent_description: newIntentDescription !== undefined && newIntentDescription !== null ? newIntentDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            old_intent_description: oldIntentDescription !== undefined && oldIntentDescription !== null ? oldIntentDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WidgetsConfigurationPreviewEvent
 */
export var WidgetsConfigurationPreview = function (_a) {
    var widgetSize = _a.widgetSize, widgetType = _a.widgetType;
    return ({
        name: "Widgets Configuration Preview",
        parameters: {
            cdf_entity: "Widgets",
            cdf_action: "Configuration",
            widget_size: widgetSize !== undefined && widgetSize !== null ? widgetSize.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            widget_type: widgetType !== undefined && widgetType !== null ? widgetType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WidgetsAppRefreshEvent
 */
export var WidgetsAppRefresh = function (_a) {
    var widgetType = _a.widgetType;
    return ({
        name: "Widgets App Refresh",
        parameters: {
            cdf_entity: "Widgets",
            cdf_action: "App",
            widget_type: widgetType !== undefined && widgetType !== null ? widgetType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WidgetsInteractionTapEvent
 */
export var WidgetsInteractionTap = function (_a) {
    var widgetSize = _a.widgetSize, widgetType = _a.widgetType, action = _a.action, deepLink = _a.deepLink;
    return ({
        name: "Widgets Interaction Tap",
        parameters: {
            cdf_entity: "Widgets",
            cdf_action: "Interaction",
            widget_size: widgetSize !== undefined && widgetSize !== null ? widgetSize.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            widget_type: widgetType !== undefined && widgetType !== null ? widgetType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            deep_link: deepLink !== undefined && deepLink !== null ? deepLink.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
